export default {
  cartRefresh: 'API_CARTREFRESH',
  apiRedirect: 'API_REDIRECT'
}
